// extracted by mini-css-extract-plugin
export default {"snapshotImgRound":"ys3DjOk2HLK95wQGpqHG"};